import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="summary-box__container">
  {{#if @topic.has_summary}}
    <p>{{html-safe this.topRepliesSummaryInfo}}</p>
  {{/if}}
  <div class="summarization-buttons">
    {{#if @topic.summarizable}}
      {{#if this.summary.showSummaryBox}}
        <DButton
          @action={{@collapseSummary}}
          @title="summary.buttons.hide"
          @label="summary.buttons.hide"
          @icon="chevron-up"
          class="btn-primary topic-strategy-summarization"
        />
      {{else}}
        <DButton
          @action={{@showSummary}}
          @translatedLabel={{this.generateSummaryTitle}}
          @translatedTitle={{this.generateSummaryTitle}}
          @icon={{this.generateSummaryIcon}}
          @disabled={{this.summary.loading}}
          class="btn-primary topic-strategy-summarization"
        />
      {{/if}}
    {{/if}}
    {{#if @topic.has_summary}}
      <DButton
        @action={{if @postStream.summary @cancelFilter @showTopReplies}}
        @translatedTitle={{this.topRepliesTitle}}
        @translatedLabel={{this.topRepliesLabel}}
        @icon={{this.topRepliesIcon}}
        class="top-replies"
      />
    {{/if}}
  </div>

  {{#if this.summary.showSummaryBox}}
    <article class="summary-box">
      {{#if (and this.summary.loading (not this.summary.text))}}
        <AiSummarySkeleton />
      {{else}}
        <div class="generated-summary">{{this.summary.text}}</div>

        {{#if this.summary.summarizedOn}}
          <div class="summarized-on">
            <p>
              {{i18n "summary.summarized_on" date=this.summary.summarizedOn}}

              <DTooltip @placements={{array "top-end"}}>
                <:trigger>
                  {{d-icon "info-circle"}}
                </:trigger>
                <:content>
                  {{i18n "summary.model_used" model=this.summary.summarizedBy}}
                </:content>
              </DTooltip>
            </p>

            {{#if this.summary.outdated}}
              <p class="outdated-summary">
                {{this.outdatedSummaryWarningText}}
              </p>
            {{/if}}
          </div>
        {{/if}}
      {{/if}}
    </article>
  {{/if}}
</div>
*/
{
  "id": "65F9TYKM",
  "block": "[[[10,0],[14,0,\"summary-box__container\"],[12],[1,\"\\n\"],[41,[30,1,[\"has_summary\"]],[[[1,\"    \"],[10,2],[12],[1,[28,[35,1],[[30,0,[\"topRepliesSummaryInfo\"]]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"summarization-buttons\"],[12],[1,\"\\n\"],[41,[30,1,[\"summarizable\"]],[[[41,[30,0,[\"summary\",\"showSummaryBox\"]],[[[1,\"        \"],[8,[39,2],[[24,0,\"btn-primary topic-strategy-summarization\"]],[[\"@action\",\"@title\",\"@label\",\"@icon\"],[[30,2],\"summary.buttons.hide\",\"summary.buttons.hide\",\"chevron-up\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,2],[[24,0,\"btn-primary topic-strategy-summarization\"]],[[\"@action\",\"@translatedLabel\",\"@translatedTitle\",\"@icon\",\"@disabled\"],[[30,3],[30,0,[\"generateSummaryTitle\"]],[30,0,[\"generateSummaryTitle\"]],[30,0,[\"generateSummaryIcon\"]],[30,0,[\"summary\",\"loading\"]]]],null],[1,\"\\n\"]],[]]]],[]],null],[41,[30,1,[\"has_summary\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"top-replies\"]],[[\"@action\",\"@translatedTitle\",\"@translatedLabel\",\"@icon\"],[[52,[30,4,[\"summary\"]],[30,5],[30,6]],[30,0,[\"topRepliesTitle\"]],[30,0,[\"topRepliesLabel\"]],[30,0,[\"topRepliesIcon\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"summary\",\"showSummaryBox\"]],[[[1,\"    \"],[10,\"article\"],[14,0,\"summary-box\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"summary\",\"loading\"]],[28,[37,4],[[30,0,[\"summary\",\"text\"]]],null]],null],[[[1,\"        \"],[8,[39,5],null,null,null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"generated-summary\"],[12],[1,[30,0,[\"summary\",\"text\"]]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"summary\",\"summarizedOn\"]],[[[1,\"          \"],[10,0],[14,0,\"summarized-on\"],[12],[1,\"\\n            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,6],[\"summary.summarized_on\"],[[\"date\"],[[30,0,[\"summary\",\"summarizedOn\"]]]]]],[1,\"\\n\\n              \"],[8,[39,7],null,[[\"@placements\"],[[28,[37,8],[\"top-end\"],null]]],[[\"trigger\",\"content\"],[[[[1,\"\\n                  \"],[1,[28,[35,9],[\"info-circle\"],null]],[1,\"\\n                \"]],[]],[[[1,\"\\n                  \"],[1,[28,[35,6],[\"summary.model_used\"],[[\"model\"],[[30,0,[\"summary\",\"summarizedBy\"]]]]]],[1,\"\\n                \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"summary\",\"outdated\"]],[[[1,\"              \"],[10,2],[14,0,\"outdated-summary\"],[12],[1,\"\\n                \"],[1,[30,0,[\"outdatedSummaryWarningText\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@topic\",\"@collapseSummary\",\"@showSummary\",\"@postStream\",\"@cancelFilter\",\"@showTopReplies\"],false,[\"if\",\"html-safe\",\"d-button\",\"and\",\"not\",\"ai-summary-skeleton\",\"i18n\",\"d-tooltip\",\"array\",\"d-icon\"]]",
  "moduleName": "discourse/components/summary-box.hbs",
  "isStrictMode": false
});